// ----- 审批流程模版相关类型 -------

export interface ProcessTemplateEdge {
  id: string;
  shape: string;
  source: string;
  target: string;
}

export enum ASSIGNEE_TYPE {
  ROLE = 'ROLE',
  FIELD = 'FIELD',
  NODE = 'NODE',
  STAFF = 'STAFF'
}

export enum ASSIGNEE_ROLE_SCOPE {
  ALL_DEPARTMENT_ROLE = 'ALL_DEPARTMENT_ROLE',
  USER_DEPARTMENT_ROLE = 'USER_DEPARTMENT_ROLE'
}

export interface BasicConfiguration {
  assigneeRoleScope: ASSIGNEE_ROLE_SCOPE;
  assigneeType: string;
  assigneeFilterRole: string[];
  name: string;
  ccFilterRole: string[];
  approvalMode: string;
}
/**
 * 审批流程节点配置
 */
export interface ProcessTemplateNode {
  id: string;
  shape: string;
  x: number;
  y: number;
  data: {
    basicConfiguration: BasicConfiguration;
  };
}

export interface ProcessTemplateElements {
  edges: ProcessTemplateEdge[];
  nodes: ProcessTemplateNode[];
}

/**
 * 审批流程模版
 */
export interface ProcessTemplate {
  approval_design_id: string;
  relation_task_id: string;
  schema_values?: ProcessTemplateElements;
}

// ---------- 审批流程实例数据

export interface ProcessComment {
  complete: boolean;
  userId: string;
  username: string;
  nodeId: string;
  processInstanceId: string;
  taskId: string;
  message?: any;
  auditType?: number;
}

export interface NeedAssignNode {
  // 待指定的节点
  assigned_node: string;
  assigneeFilterRole?: string[];
  assigneeRoleScope?: ASSIGNEE_ROLE_SCOPE;
  ccFilterRole?: string[];
  // 当前用户
  userAccount?: string;
  // 当前节点id
  node: string;
  nodeName: string;
  task_id: string;
  set_assignee: boolean;
  set_cc: boolean;
}

/**
 * 流程实例节点
 */
export interface ProcessNode {
  nodeId: string;
  needAssign: boolean;
  needAssignNodes: NeedAssignNode[];
  comments: ProcessComment[];
  complete: boolean;
}

export interface ProcessParams {
  taskId: string;
  dataId: string;
  version: string;
}

export interface ProcessVariables {
  userAccount: string;
}

// ----- 审批流程渲染数据 ------


export type ProcessTemplateNodeExt = {
  name: string;
  title: {
    label: string;
    approvalType: string;
  };
} & ProcessTemplateNode;

export interface RenderProcessTemplateNode {
  nodeId?: string;
  needAssign?: boolean;
  needAssignNodes?: NeedAssignNode[];
  comments?: ProcessComment[];
  complete?: boolean;
  name: string;
  title: {
    label: string;
    approvalType: string;
  };
  showNode: boolean;
  userAccount?: string;
  id?: string;
}


export type RenderFormatDescription = ProcessComment & { message: object; type: string; notice: boolean };

export type RenderFormatProcessTemplateNode = RenderProcessTemplateNode & {
  description: RenderFormatDescription[];
  isRefuse: boolean;
};
